import React from 'react'
import { FaW, FaWhatsapp } from 'react-icons/fa6';
import { Link, useLocation } from 'react-router-dom';

function AnyChatWidget() {
  const location = useLocation();

  // List of allowed paths where the widget should be shown
  const allowedPaths = ['/', '/course-content', '/profile'];

  // Check if the current path is in the allowedPaths array or starts with '/course/'
  const showWidget = allowedPaths.includes(location.pathname) || location.pathname.startsWith('/course/');

  if (!showWidget) return null; // Return null to prevent rendering the widget on other pages
  return (
    <Link to={'https://wa.me/8801710090043?text=আমি%20কামব্যাক%20কোর্সে%20ভর্তি%20হতে%20চাই'}>
      <div
        className="fixed bottom-6 right-6 bg-white rounded-full shadow-lg flex items-center px-3 py-2 cursor-pointer hover:scale-105 transition-all z-50"
      >
        <div className="relative">
          {/* 🔴 Pulse animation */}
          <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-75 animate-ping"></span>

          {/* Icon with background */}
          <div className="relative bg-[#25D366] p-3 rounded-full text-white z-10">
            <FaWhatsapp className="w-20 h-20   md:h-12 md:w-12 lg:w-12 lg:h-12" />
            {/* <span className="absolute -top-1 -right-1 bg-orange-600 text-white text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full">
                            2
                        </span> */}
          </div>
        </div>
      </div>
    </Link>
  )
}

export default AnyChatWidget
